import styled from "styled-components";

export const Container = styled.main `
    height: 100%;
    width: 100%;
    background-color: ${props => props.theme.colors.brand4.pure};
    padding: 33px 0;
`

export const UserWishlistInfoContainer = styled.div `
    margin: 0 auto;
    width: 92%;
    display: flex;
    flex-direction: column;

    @media(min-width:768px){
        width: 700px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
    }   
`

export const FooterButtonContent = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;

    > svg {
        width: 20px;
        height: 20px;
        margin-right: 8px;

        @media(min-width:480px) {
            width: 26px;
            height: 26px;
        }

        @media(min-width:768px) {
            width: 16px;
            height: 16px;
        }
    }

    > span {
        font-weight: 550;
        font-size: 1rem;
        line-height: initial;
        color: ${props => props.theme.colors.typography2.dark};
        text-transform: uppercase;

        @media(min-width:480px) {
            font-weight: 550;
            font-size: 1.3rem;
            line-height: 30px;
        }

        @media(min-width:768px) {
            font-size: 0.75rem;
            line-height: 15px;
        }
    }
`